/*
* Copyright (c) 2022 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/

import { Component, OnInit, HostListener } from '@angular/core';
import { KbaResponse, KbaBasicInfo } from '../model/kbaresponse';
import { KbaService } from '../services/kba.service';
import { KnowledgeBaseFilterInfo } from '../model/knowledgebasefilterinfo';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ZSDTranslateService } from '../../../../common/zsd-translate.service';
import { CommonConstants } from '../../../../common/constants/common-constants';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BannerComponent } from '../../../view/banner/banner.component';
import { SpinnerService } from '../../../../shared/spinner/spinner.service';
import { ItemCategoriesResultEntity } from '../../shared/model/itemcategoriesresponse';
import { ItemTypesResultEntity } from '../../shared/model/itemtypesresponse';
import { take } from 'rxjs/operators';
import { CustomerPreferenceService } from './../../../preference/customerpreference.service';
import { CustomerPreferenceResponse } from './../../../preference/customerpreference.model';

declare var $: any;
declare var moment: any;
@Component({
  selector: 'zsd-knowledgebase',
  templateUrl: '../view/knowledgebase.component.html',
  styleUrls: ['../view/knowledgebase.component.scss']
})
export class KnowledgeBaseComponent implements OnInit {
  static createdFromDate: string;
  static createdToDate: string;
  static sun: string;
  static mon: string;
  static tue: string;
  static wed: string;
  static thu: string;
  static fri: string;
  static sat: string;
  static jan: string;
  static feb: string;
  static mar: string;
  static apr: string;
  static may: string;
  static jun: string;
  static jul: string;
  static aug: string;
  static sep: string;
  static oct: string;
  static nov: string;
  static dec: string;
  kbaResponse: KbaBasicInfo[] = [];
  kbaResultsCount = 0;
  kbaArticleCount = 0;
  kbaFaqCount = 0;
  kbaSolutionCount = 0;
  knowledgebasefilterinfo: KnowledgeBaseFilterInfo = new KnowledgeBaseFilterInfo();
  kbaDataFound = true;
  noRecords: string;
  maxNoOfItems: number;
  isKbalist: boolean;
  scrollEndReached = false;
  kbaPerPage = 20;
  page = 0;
  sortBy = 'created';
  sortOrder = 'DESC';
  isLoading = false;
  isDesc = true;
  column: string;
  spinnerStart = true;
  readonly KBA_TYPE_ARTICLE = 1000;
  readonly KBA_TYPE_FAQ = 2000;
  readonly KBA_TYPE_SOLUTION = 4000;
  kbaBasicInfoResponse = new Array<KbaBasicInfo>();
  kbaCommentEnabledForCustomer: boolean;


  static selectedCategories = null;
  static selectedItemTypes = null;
  static categoryIds = null;

  optionSelected;
  allKba = 'all';
  article = 'article';
  faqs = 'faqs';
  solution = 'solution';

  categoryResults = new Array<ItemCategoriesResultEntity>();
  itemTypesResults = new Array<ItemTypesResultEntity>();

  constructor(public kbaService: KbaService,
    private route: ActivatedRoute, private zsdTranslate: ZSDTranslateService, public http: HttpClient,
     public spinnerService: SpinnerService, public router: Router, public customerPreferenceService: CustomerPreferenceService) {
       this.getCustomerPreferences();
      if (this.zsdTranslate.getTranslateService().store.translations[this.zsdTranslate.getTranslateService().currentLang]) {
        // check if translated json file already available
        this.initializeDateTimePicker();
      } else {
        // wait for new translated json file to get loaded by subscribing to it
        this.zsdTranslate.getTranslateService().onDefaultLangChange.pipe(take(1)).subscribe(_ => this.initializeDateTimePicker());
      }
  }

  getCustomerPreferences() {
    this.customerPreferenceService.getPreferenceList().subscribe(
        (preferences: CustomerPreferenceResponse) => {
          this.kbaCommentEnabledForCustomer = preferences.kbaCommentEnabledForCustomer;
         },
        err => console.error(err)
      );
}

  ngOnInit() {
    /* $(document).ready(() => {
      this.initializeDateTimePicker();
    }); */
    /* To refresh Global search dropdown */
    BannerComponent.refreshGlobalSearchDropdown.next(false);
    this.resetFilter();
    this.sort('created');
    $(document).ready(() => {
    $('#reportranged,#reportrangem').on('apply.daterangepicker', () => {
      this.knowledgebasefilterinfo.createdFromDate = KnowledgeBaseComponent.createdFromDate;
      this.knowledgebasefilterinfo.createdToDate = KnowledgeBaseComponent.createdToDate;
      this.isLoading = false;
      this.page = 0;
      this.kbaBasicInfoResponse = [];
      this.getKbasList(this.page, this.sortBy, this.sortOrder, this.knowledgebasefilterinfo);
    });
  });
  }
  sort(property: string) {
    this.initializeItemsParameters();
    $('#property').removeClass('fa fa-sort');
    this.isDesc = !this.isDesc;
    this.column = property;
    if (this.isDesc === true) {
      this.sortOrder = 'ASC';
    } else {
      this.sortOrder = 'DESC';
    }
    this.sortBy = property;

    this.initFilter();
    this.applyFilterParamaeter(this.knowledgebasefilterinfo);
    this.isLoading = true;
    this.spinnerService.show();
  }

  applyFilterParamaeter(knowledgebasefilterinfo: KnowledgeBaseFilterInfo) {
    if (knowledgebasefilterinfo) {
      if (knowledgebasefilterinfo.kbaTabType === null) {
        knowledgebasefilterinfo.kbaType = null;
      }
      this.getKbasList(this.page, this.sortBy, this.sortOrder, knowledgebasefilterinfo);
    } else {
        knowledgebasefilterinfo.searchTerm = '';
        knowledgebasefilterinfo.categoryIds = [];
        knowledgebasefilterinfo.itemTypeIds = [];
        knowledgebasefilterinfo.kbaTabType = this.allKba;
      this.getKbasList(this.page, this.sortBy, this.sortOrder, knowledgebasefilterinfo);
    }
  }

  initFilter() {
    let categoryIds = new Array<number>();
    let itemTypeIds = new Array<number>();

    this.route.queryParams.subscribe(params => {
      if (params['searchTerm']) {
        this.knowledgebasefilterinfo.searchTerm = JSON.parse(params['searchTerm']);
      }
      if (params['categoryIds']) {
        categoryIds = JSON.parse(params['categoryIds']);
      }
      if (params['itemTypeIds']) {
        itemTypeIds = JSON.parse(params['itemTypeIds']);
      }
      if (params['kbaType']) {
        this.knowledgebasefilterinfo.kbaTabType = JSON.parse(params['kbaType']);
        if (this.knowledgebasefilterinfo.kbaTabType === this.allKba) {
             this.knowledgebasefilterinfo.kbaType = null;
        } else if (this.knowledgebasefilterinfo.kbaTabType === this.article) {
        this.knowledgebasefilterinfo.kbaType = this.KBA_TYPE_ARTICLE;
        } else if (this.knowledgebasefilterinfo.kbaTabType === this.faqs) {
        this.knowledgebasefilterinfo.kbaType = this.KBA_TYPE_FAQ;
        } else if (this.knowledgebasefilterinfo.kbaTabType === this.solution) {
        this.knowledgebasefilterinfo.kbaType = this.KBA_TYPE_SOLUTION;
        }
      } else {
        this.knowledgebasefilterinfo.kbaType = null;
      }
    });

    this.knowledgebasefilterinfo.categoryIds = categoryIds;
    this.knowledgebasefilterinfo.itemTypeIds = itemTypeIds;
  }

  getKbasList(pageNo: number, sortBy: string, sortOrder: string, knowledgebasefilterinfo: KnowledgeBaseFilterInfo) {
    let params = new HttpParams()
      .set('offset', this.page.toString())
      .set('limit', this.kbaPerPage.toString())
      .set('sortBy', this.sortBy)
      .set('sortOrder', this.sortOrder);


    if (!this.isLoading) {
      this.isLoading = true;
      this.spinnerService.show();
      if (pageNo === -1) {
        this.isLoading = true;
        this.spinnerService.show();
        this.page = 0;
        this.sortBy = sortBy;
        this.sortOrder = sortOrder;
        this.initializeItemsParameters();
        pageNo = 0;
      }
      this.http
          .post<KbaResponse>(
            CommonConstants.SERVICE_VERSION_PATH_V1 + '/customer/kbas',
            knowledgebasefilterinfo, { params }
          ).subscribe(resp => {
            this.maxNoOfItems = resp.resultCount;
            this.kbaArticleCount = resp.articleCount;
            this.kbaFaqCount = resp.faqCount;
            this.kbaSolutionCount = resp.solutionCount;
            this.kbaResultsCount = this.kbaArticleCount + this.kbaFaqCount + this.kbaSolutionCount;
            if (this.maxNoOfItems > 0) {
              this.isKbalist = true;
              this.scrollEndReached = false;
            }
            this.kbaBasicInfoResponse = this.kbaBasicInfoResponse.concat(
              resp.results
          );
          let i = 0;
          this.kbaBasicInfoResponse.forEach(function(object) {
            $(function () {
              $('#rateYo' + i++).rateYo({
                starWidth: '16px',
                rating: object.averageRating,
                ratedFill: '#15DB66',
                normalFill: '#D4D6DA',
                readOnly: true
              });
            });
          });
            this.page++;
            if (this.kbaBasicInfoResponse.length >= this.maxNoOfItems) {
              // reached end of list
              this.scrollEndReached = true;
            }
            this.isLoading = false;
            this.spinnerStart = false;
            this.kbaDataFound = resp.resultCount > 0;
            if (!this.kbaDataFound) {
              this.noResultsFound(this.knowledgebasefilterinfo);
            }
          },
            err => {
              console.log(err);
              this.kbaDataFound = false;
              this.kbaResponse = null;
              this.kbaArticleCount = 0;
              this.kbaFaqCount = 0;
              this.kbaSolutionCount = 0;
              this.kbaResultsCount = 0;
              this.isLoading = false;
              this.spinnerStart = false;
              this.noResultsFound(this.knowledgebasefilterinfo);
            }
          );
        }
      }
noResultsFound(knowledgebasefilterinfo: KnowledgeBaseFilterInfo) {
    if ( knowledgebasefilterinfo === null ||
      !knowledgebasefilterinfo.kbaType ||
      knowledgebasefilterinfo.kbaType === null) {
      this.noRecords = 'DataTableList.noRecords';
    } else {
    switch (knowledgebasefilterinfo.kbaType) {
      case this.KBA_TYPE_ARTICLE:
          this.noRecords = 'DataTableList.noRecords';
          break;
      case this.KBA_TYPE_FAQ:
            this.noRecords = 'DataTableList.noRecords';
            break;
      case this.KBA_TYPE_SOLUTION:
          this.noRecords = 'DataTableList.noRecords';
          break;
    }
  }
}
scrollEnd() {
  if (!this.scrollEndReached) {
    this.initFilter();
    this.getKbasList(this.page, this.sortBy, this.sortOrder, this.knowledgebasefilterinfo);
  }
}
scrollCur() {
}
trackByItems(index) {
  return index;
}

  @HostListener('window:beforeunload', ['$event']) unloadHandler() {
    new KnowledgeBaseComponent(
      this.kbaService,
      this.route, this.zsdTranslate, this.http,
      this.spinnerService , this.router , this.customerPreferenceService);
  window.scrollTo(0, 0);
}
initializeItemsParameters() {
  this.isLoading = false;
  this.page = 0;
  this.isKbalist = false;
  this.kbaBasicInfoResponse = [] ;
}

  onChangeKbaType(option: string) {
    this.isLoading = false;
    this.page = 0;
    this.kbaBasicInfoResponse = [];
    if (option === 'all') {
      this.knowledgebasefilterinfo.kbaType = null;
    }
    if (option === 'article') {
      this.knowledgebasefilterinfo.kbaType = this.KBA_TYPE_ARTICLE;
    }

    if (option === 'faqs') {
      this.knowledgebasefilterinfo.kbaType = this.KBA_TYPE_FAQ;
    }

    if (option === 'solution') {
      this.knowledgebasefilterinfo.kbaType = this.KBA_TYPE_SOLUTION;
    }
   this.applyFilterOnkbatabChange();
  }

  initializeDateTimePicker() {
    let allLabel = this.zsdTranslate.getTranslatedString('CommonStrings', 'all');
    let lastWeekLabel = this.zsdTranslate.getTranslatedString('CommonStrings', 'lastWeek');
    let lastMonthLabel = this.zsdTranslate.getTranslatedString('CommonStrings', 'lastMonth');
    let customLabel = this.zsdTranslate.getTranslatedString('CommonStrings', 'custom');
    let applyLabel = this.zsdTranslate.getTranslatedString('CommonStrings', 'applyButton');
    let cancelLabel = this.zsdTranslate.getTranslatedString('CommonStrings', 'cancelButton');
    KnowledgeBaseComponent.sun = this.zsdTranslate.getTranslatedString('CommonStrings', 'sun');
    KnowledgeBaseComponent.mon = this.zsdTranslate.getTranslatedString('CommonStrings', 'mon');
    KnowledgeBaseComponent.tue = this.zsdTranslate.getTranslatedString('CommonStrings', 'tue');
    KnowledgeBaseComponent.wed = this.zsdTranslate.getTranslatedString('CommonStrings', 'wed');
    KnowledgeBaseComponent.thu = this.zsdTranslate.getTranslatedString('CommonStrings', 'thu');
    KnowledgeBaseComponent.fri = this.zsdTranslate.getTranslatedString('CommonStrings', 'fri');
    KnowledgeBaseComponent.sat = this.zsdTranslate.getTranslatedString('CommonStrings', 'sat');
    KnowledgeBaseComponent.jan = this.zsdTranslate.getTranslatedString('CommonStrings', 'jan');
    KnowledgeBaseComponent.feb = this.zsdTranslate.getTranslatedString('CommonStrings', 'feb');
    KnowledgeBaseComponent.mar = this.zsdTranslate.getTranslatedString('CommonStrings', 'mar');
    KnowledgeBaseComponent.apr = this.zsdTranslate.getTranslatedString('CommonStrings', 'apr');
    KnowledgeBaseComponent.may = this.zsdTranslate.getTranslatedString('CommonStrings', 'may');
    KnowledgeBaseComponent.jun = this.zsdTranslate.getTranslatedString('CommonStrings', 'jun');
    KnowledgeBaseComponent.jul = this.zsdTranslate.getTranslatedString('CommonStrings', 'jul');
    KnowledgeBaseComponent.aug = this.zsdTranslate.getTranslatedString('CommonStrings', 'aug');
    KnowledgeBaseComponent.sep = this.zsdTranslate.getTranslatedString('CommonStrings', 'sep');
    KnowledgeBaseComponent.oct = this.zsdTranslate.getTranslatedString('CommonStrings', 'oct');
    KnowledgeBaseComponent.nov = this.zsdTranslate.getTranslatedString('CommonStrings', 'nov');
    KnowledgeBaseComponent.dec = this.zsdTranslate.getTranslatedString('CommonStrings', 'dec');

   $(function() {
     $('#reportranged span,#reportrangem span').html(allLabel);
     let start = moment();
     let end = moment();

     $('#reportranged,#reportrangem').daterangepicker({
         startDate: start,
         endDate: end,
         timePicker: false,
         showDropdowns: true,
         opens: 'left',
         timePickerIncrement: false,
         alwaysShowCalendars: false,
         linkedCalendars: false,
         locale: {
          'format': 'MM/DD/YYYY',
          'applyLabel': applyLabel,
          'cancelLabel': cancelLabel,
          'customRangeLabel': customLabel,
          'daysOfWeek': [
            KnowledgeBaseComponent.sun,
            KnowledgeBaseComponent.mon,
            KnowledgeBaseComponent.tue,
            KnowledgeBaseComponent.wed,
            KnowledgeBaseComponent.thu,
            KnowledgeBaseComponent.fri,
            KnowledgeBaseComponent.sat
            ],
          'monthNames': [
            KnowledgeBaseComponent.jan,
            KnowledgeBaseComponent.feb,
            KnowledgeBaseComponent.mar,
            KnowledgeBaseComponent.apr,
            KnowledgeBaseComponent.may,
            KnowledgeBaseComponent.jun,
            KnowledgeBaseComponent.jul,
            KnowledgeBaseComponent.aug,
            KnowledgeBaseComponent.sep,
            KnowledgeBaseComponent.oct,
            KnowledgeBaseComponent.nov,
            KnowledgeBaseComponent.dec
          ]

        },
         ranges: {
            [allLabel]: [moment(), moment()],
            [lastWeekLabel]: [moment().subtract(6, 'days'), moment()],
            [lastMonthLabel]:  [moment().subtract(29, 'days'), moment()],
         }
     },  function (startDate, endDate, label) {
            if (label === allLabel) {
              $('#reportranged span,#reportrangem span').html(allLabel);
              KnowledgeBaseComponent.createdFromDate = null;
              KnowledgeBaseComponent.createdToDate = null;
            } else if (label === lastWeekLabel) {
                $('#reportranged span,#reportrangem span').html(lastWeekLabel);
                KnowledgeBaseComponent.createdFromDate = startDate.format('MM/D/YY');
                KnowledgeBaseComponent.createdToDate = endDate.format('MM/D/YY');
            } else if (label === lastMonthLabel) {
                $('#reportranged span,#reportrangem span').html(lastMonthLabel);
                KnowledgeBaseComponent.createdFromDate = startDate.format('MM/D/YY');
                KnowledgeBaseComponent.createdToDate = endDate.format('MM/D/YY');
            } else {
                 $('#reportranged span,#reportrangem span').html(customLabel);
                 KnowledgeBaseComponent.createdFromDate =  startDate.format('MM/D/YY');
                 KnowledgeBaseComponent.createdToDate = endDate.format('MM/D/YY');
            }
     });
   });
 }

 increaseViewCount(kbaId: number) {
  this.kbaService.increaseViewCount(kbaId).subscribe();
 }

 resetFilter() {
  KnowledgeBaseComponent.selectedCategories = null;
  KnowledgeBaseComponent.selectedItemTypes = null;
  this.categoryResults.forEach(category => category.checked = false);
  this.itemTypesResults.forEach(itemType => itemType.checked = false);
}

applyFilterOnkbatabChange() {
  let categoryIds = new Array<number>();
  let itemTypeIds = new Array<number>();

  this.route.queryParams.subscribe(params => {
    if (params['searchTerm']) {
      this.knowledgebasefilterinfo.searchTerm = JSON.parse(params['searchTerm']);
    }
    if (params['categoryIds']) {
      categoryIds = JSON.parse(params['categoryIds']);
    }
    if (params['itemTypeIds']) {
      itemTypeIds = JSON.parse(params['itemTypeIds']);
    }
  });
  this.knowledgebasefilterinfo.categoryIds = categoryIds;
  this.knowledgebasefilterinfo.itemTypeIds = itemTypeIds;
  this.categoryResults = this.categoryResults.filter(category => category.checked === true);
  this.itemTypesResults = this.itemTypesResults.filter(itemType => itemType.checked === true);

    for (let itemCategory of this.categoryResults) {
      categoryIds.push(itemCategory.categoryId);
    }

    for (let itemType of this.itemTypesResults) {
      itemTypeIds.push(itemType.itemTypeId);
    }

    if (this.knowledgebasefilterinfo.searchTerm !== null) {
      this.knowledgebasefilterinfo.searchTerm = JSON.stringify(this.knowledgebasefilterinfo.searchTerm);
    }

    if (this.knowledgebasefilterinfo.kbaType === null) {
          this.knowledgebasefilterinfo.kbaTabType = this.allKba;
    }
    if ( this.knowledgebasefilterinfo.kbaType === this.KBA_TYPE_ARTICLE) {
      this.knowledgebasefilterinfo.kbaTabType = this.article;
    }
    if ( this.knowledgebasefilterinfo.kbaType === this.KBA_TYPE_FAQ) {
      this.knowledgebasefilterinfo.kbaTabType = this.faqs;
    }
    if ( this.knowledgebasefilterinfo.kbaType === this.KBA_TYPE_SOLUTION) {
      this.knowledgebasefilterinfo.kbaTabType = this.solution;
    }

    this.knowledgebasefilterinfo.kbaTabType = JSON.stringify(this.knowledgebasefilterinfo.kbaTabType);

    if (categoryIds.length > 0) {
      KnowledgeBaseComponent.selectedCategories = JSON.stringify(categoryIds);
      this.knowledgebasefilterinfo.categoryIds = categoryIds;
    }
    if (itemTypeIds.length > 0) {
      KnowledgeBaseComponent.selectedItemTypes = JSON.stringify(itemTypeIds);
      this.knowledgebasefilterinfo.itemTypeIds = itemTypeIds;
    }

    let navigationExtras: NavigationExtras = {
      queryParams: {
        'searchTerm': this.knowledgebasefilterinfo.searchTerm,
        'categoryIds': KnowledgeBaseComponent.selectedCategories,
        'itemTypeIds': KnowledgeBaseComponent.selectedItemTypes,
        'kbaType': this.knowledgebasefilterinfo.kbaTabType
      },
      queryParamsHandling: 'merge'
    };

    this.router.navigateByUrl('/my-profile', { skipLocationChange: true }).then(() =>
      this.router.navigate([CommonConstants.SELFHELP_COMPONENT], navigationExtras ));

}
}
